import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { SalaryConfirmSearchParam } from '../../models/gen/salaryConfirmSearchParam';
import { SalaryConfirmSearchResult } from '../../models/gen/salaryConfirmSearchResult';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const SALARY_CONFIRM_CONTEXT_NAMES = {
  POST_SALARY_CONFIRM_SEARCH: 'searchSalaryConfirm',
} as const;

const apis = apiGenerator();

/**
 * POST /salary-confirm/search
 *
 * @param param -
 * @returns
 */
export const usePostSalaryConfirmSearch = () =>
  useGenericMutation(async (param: SalaryConfirmSearchParam) =>
    apis.post<SalaryConfirmSearchParam, SalaryConfirmSearchResult>(
      `${env.BASE_API_ENDPOINT}/salary-confirm/search`,
      { ...queryOptions, data: param }
    )
  );
